import { render, staticRenderFns } from "./InfoState.vue?vue&type=template&id=a234b47a&scoped=true"
import script from "./InfoState.vue?vue&type=script&lang=js"
export * from "./InfoState.vue?vue&type=script&lang=js"
import style0 from "./InfoState.vue?vue&type=style&index=0&id=a234b47a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a234b47a",
  null
  
)

export default component.exports